import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldCheck, BarChart3 } from "lucide-react";

const LOGO_URL = "/cgi-logo.png";
const CGI_WEBSITE = "https://www.commongroundinstitute.net";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <header
      className="sticky top-0 z-30 w-full bg-cream/90 backdrop-blur-md border-b border-amber-100"
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a
          href={CGI_WEBSITE}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3"
          data-testid="header-logo-link"
          aria-label="Visit the Common Ground Institute website"
        >
          <img src={LOGO_URL} alt="Common Ground Institute" className="h-14 w-auto object-contain rounded-md" />
        </a>

        {user && (
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline text-sm text-slate-600" data-testid="header-user-name">
              {user.name}
            </span>
            {user.role === "admin" && (
              <>
                <Button asChild variant="outline" size="sm" className="gap-2" data-testid="header-admin-assessments-link">
                  <Link to="/admin/assessments">
                    <BarChart3 className="h-4 w-4" />
                    <span className="hidden sm:inline">Assessments</span>
                  </Link>
                </Button>
                <Button asChild variant="outline" size="sm" className="gap-2" data-testid="header-admin-link">
                  <Link to="/admin/feedback">
                    <ShieldCheck className="h-4 w-4" />
                    <span className="hidden sm:inline">Feedback</span>
                  </Link>
                </Button>
              </>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              data-testid="header-logout-button"
              className="gap-2"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Sign out</span>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
